import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  withStyles,
  Tooltip,
  withTheme,
} from '@material-ui/core';
import styles from './MapPopupStyles.js';
import './style.scss';
import {
  getFormattedDeliveryWindowList,
  getDeliveryWindowByEarlyAndLateCTA
} from '@dataGrid/gridUtilities';
import { getCombinedIconsArray, getIconByType } from './PopupUtil';
import {
  getCustomerName,
  getCustomerAddress,
  getCustomerCity
} from '../../modules/IBPlanning/ShipmentsView/utils.js';
import { compose } from 'recompose';

function ShipmentPopupInfo(props) {
  const { classes, theme } = props;
  const name = getCustomerName(props);
  const address = getCustomerAddress(props);
  const city = getCustomerCity(props);
  const combinedAddress = `${address}, ${city}`;
  const combinedIconsArray = getCombinedIconsArray({ shipmentData: props.data, specialNeedsOptions: props.specialNeedsOptions});
  const params = {
    data: {
      priority: props.data.priority,
      apt: props.data.apt
    },
    value: props.data.deliveryWindow
  };
  const themeName = theme.themeName;
  return (
    <Paper className={`${classes.root} popupBGColor`}>
      <Table className={classes.table} padding="none">
        <TableHead className={classes.tableHead}>
          <TableRow className={classes.tableHeadHeight}>
            <TableCell colSpan={2} className={classes.tableHeaderCell}>
              <Tooltip classes={{ popper: 'popper', tooltip: `tooltip-${themeName}` }} title={name}>
                <div className={classes.customerName}>{name}</div>
              </Tooltip>
              <Tooltip
                classes={{ popper: 'popper', tooltip: `tooltip-${themeName}` }}
                title={props.data.routeName}>
                <span className={classes.routeInfo}>{props.data.routeName}</span>
              </Tooltip>
              <Tooltip
                classes={{ popper: 'popper', tooltip: `tooltip-${themeName}` }}
                title={combinedAddress}>
                <div className={classes.address}>{combinedAddress}</div>
              </Tooltip>
              <div className={classes.popupIconContainer}>
                {combinedIconsArray.slice(0, 5).map((element) => (
                  <Tooltip
                    key={element.value}
                    classes={{ popper: 'popper', tooltip: `tooltip-${themeName}` }}
                    title={element.tooltip}>
                    <div className={classes.popupIcon}>
                      {getIconByType({ iconData: element, backgroundColor: theme.headFontColor })}
                    </div>
                  </Tooltip>
                ))}
              </div>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow className={classes.tableRowRoot}>
            <TableCell
              className={`${classes.nameCellPadding} ${classes.labelCell} ${classes.firstTableCell} tableCellName`}>
              Pro ID
            </TableCell>
            <TableCell className={`${classes.dataCell} ${classes.firstTableCell} tableCellValue`}>
              {props.data.proId}
            </TableCell>
          </TableRow>
          <TableRow className={classes.tableRowRoot}>
            <TableCell className={`${classes.nameCellPadding} ${classes.labelCell} tableCellName`}>
              Service Window
            </TableCell>
            <TableCell className={`${classes.dataCell} tableCellValue`}>
              {getDeliveryWindowByEarlyAndLateCTA(props.data) ||
                getFormattedDeliveryWindowList(params).map((deliverySlot, index) => (
                  <React.Fragment key={index}>
                    <span>{deliverySlot}</span>
                    <br />
                  </React.Fragment>
                ))}
            </TableCell>
          </TableRow>
          <TableRow className={classes.tableRowRoot}>
            <TableCell
              className={`${classes.nameCellPadding} ${classes.labelCell} ${
                props.data.shipmentSpecialInstruction ? '' : classes.lastTableCell
              } tableCellName`}>
              <div className={classes.dualCellLeft}>Weight</div>
              <div className={classes.dualCellRight}>PSE</div>
            </TableCell>
            <TableCell
              className={`${classes.dataCell} ${
                props.data.shipmentSpecialInstruction ? '' : classes.lastTableCell
              } tableCellValue`}>
              <div className={classes.dualCellLeft}>{props.data.weight} lbs</div>
              <div className={classes.dualCellRight}>{props.data.pse}</div>
            </TableCell>
          </TableRow>
          {props.data.shipmentSpecialInstruction && (
            <TableRow className={classes.tableRowRoot}>
              <TableCell
                className={`${classes.nameCellPadding} ${classes.labelCell} ${classes.lastTableCell} tableCellName`}>
                Special Instructions
              </TableCell>
              <TableCell className={`${classes.dataCell} ${classes.lastTableCell} tableCellValue`}>
                <Tooltip
                  classes={{ popper: 'popper', tooltip: `tooltip-${themeName}` }}
                  title={props.data.shipmentSpecialInstruction}>
                  <div className={classes.SpecialInstruction}>
                    {props.data.shipmentSpecialInstruction}
                  </div>
                </Tooltip>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Paper>
  );
}

export default compose(withStyles(styles),withTheme())(ShipmentPopupInfo);
